import type { FaireProductEntity } from "../../entity_types/product";

export const p_s8fwvuhx9a: FaireProductEntity = {
  token: "p_s8fwvuhx9a",
  type: "product",
  name: "3pc Chrysocolla Spheres ~ Polished Crystals & Minerals",
  brandToken: "b_t2bh3wmq82",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ca8745a28fa4bbc9952131e311647d2e9baaac7a53fd1d81e9381603e0c95b49.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/65598c7bcbaa4d04b68a1417134f6eed5d0e1f071c6cf21cb1e34bf9647517b4.jpeg",
    "https://cdn.faire.com/fastly/075f726ed5003f5ad891ca0baa8fd6da5cfa51334afb6ca123ef8df1653280ee.jpeg",
    "https://cdn.faire.com/fastly/2a3ddedcbe11e5dec1b73c92664bc0dc6524b4c0cd716c5311504937b0fa64b2.jpeg",
    "https://cdn.faire.com/fastly/db76b97de65dfc10c401ffea87c4ee4ecdcef440089611bbb8827b8da730b672.jpeg",
    "https://cdn.faire.com/fastly/81c0b4f3a4891828bf7c31585828e8ccb2ce22ec6bbfc95b8b08fd62e3b82e8e.jpeg",
  ],
  priceDollars: 91.46,
  description:
    "This listing is for 3 pieces of Chrysocolla Spheres from Peru.\n\nChrysocolla is known as a stone of communication, emotional healing, and empowerment. Believed to encourage self-expression, soothe stress, and promote balance, it is often associated with the throat and heart chakras. This calming stone is cherished for its ability to inspire compassion, foster understanding, and help release negative emotions.\n\nScientifically, Chrysocolla is a hydrated copper silicate mineral with the chemical formula (Cu,Al)₂H₂Si₂O₅(OH)₄·nH₂O. Its vibrant blue-green color comes from its copper content. Chrysocolla has a Mohs hardness of 2 to 4.\n\nHistorically, Chrysocolla has been used since antiquity in decorative arts and jewelry, particularly by ancient Egyptians, who valued it for its beauty and calming properties. ",
  tags: [],
  msrpDollars: 182.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:28.106Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
